import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';

import {
  WorkOrderObservation,
  CreateWorkOrderObservationRequest,
  UpdateWorkOrderObservationRequest,
} from './WorkOrdersObservations.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/workorders/complements`;

export async function listWorkOrderObservations(
  workOrderComplementId?: number,
  params?: PageRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${workOrderComplementId}/observations`,
    params,
  )) as unknown;

  return result as WorkOrderObservation[];
}

export async function createWorkOrderObservation(
  obj: CreateWorkOrderObservationRequest,
): Promise<WorkOrderObservation> {
  const result = (await api.post(
    `${CONTROLLER_URL}/${obj.workOrderComplementId}/observations`,
    obj,
    null,
  )) as unknown;

  return result as WorkOrderObservation;
}

export async function updateWorkOrderObservation(
  obj: UpdateWorkOrderObservationRequest,
): Promise<WorkOrderObservation> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.workOrderComplementId}/observations/${obj.observationId}`,
    obj,
    null,
  )) as unknown;

  return result as WorkOrderObservation;
}

export async function deleteWorkOrderObservation(
  workOrderComplementId: number,
  observationId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${workOrderComplementId}/observations/${observationId}`,
    {},
    null,
  )) as unknown;

  return result;
}
